import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import points from "./img/points.png";
import icLogo from "./img/icLogo.png";
import vuse from "./img/vuse.png";
import glo from "./img/glo.png";
import both from "./img/both.png";
import noneCoupe from "./img/noneC.png";
import collection from "./img/collection.png";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { parseCMSBold } from "@app/Helpers";
import AwardCard from "@components/AwardCard";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default function JourneyStory({
  ident,
  currentIndexInGroup,
  setIsAssetReady,
  isStoryPaused,
  isCurrentStory,
  data,
  getData,
}) {
  const [storyOverlayColor, setStoryOverLayColor] = useState("");

  useEffect(() => {
    if (isCurrentStory) {
      setIsAssetReady(true);
    }
  }, [isStoryPaused, currentIndexInGroup, isCurrentStory]);

  const PilarDiagram = ({ dataValues, highlightIndex }) => {
    const data = {
      labels: ["M", "D", "M", "D", "F", "S", "S"],
      datasets: [
        {
          data: dataValues,
          backgroundColor: dataValues.map((_, index) =>
            index === highlightIndex ? "#3EC7DA" : "#FFFFFF"
          ),
          borderRadius: 25,
        },
      ],
    };

    const options = {
      plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: { color: "#FFFFFF" },
        },
        y: {
          grid: { display: false },
          ticks: { display: false },
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    };

    return (
      <div className="pilar-diagram" style={{ width: "100%", height: "250px" }}>
        <Bar data={data} options={options} />
      </div>
    );
  };

  return (
    <div className={`journey-component`}>
      <div
        className="journey-inner-overlay"
        style={{ backgroundColor: storyOverlayColor.rgba }}
      />
      <div className="journey-content">
        {(() => {
          switch (ident) {
            case "intro":
              return (
                <div className="content-wrapper intro">
                  <div className="intro-badge">
                    <strong>Inspiration </strong>
                    <br />
                    Journey
                    <br />
                    <span>
                      20
                      <br /> 25
                    </span>
                  </div>
                  <p className="title">
                    <strong>
                      1 Jahr
                      <br /> Inspiration
                      <br /> Club!
                    </strong>
                  </p>
                  <p className="des">
                    Schau dir an, wie wir
                    <br /> dieses Jahr <strong>gemeinsam</strong>
                    <br />
                    erlebt haben.
                  </p>
                </div>
              );
            case "blue-1":
              return (
                <div className="content-wrapper blue">
                  <div className="badge blue">
                    <strong>Inspiration </strong>
                    Journey
                    <span>
                      20
                      <br /> 25
                    </span>
                  </div>
                  <p className="title">
                    <strong>Dein kleiner</strong>
                    <br /> <span>großer Triumph</span>
                  </p>
                </div>
              );
            case "blue-2":
              return (
                <div className="content-wrapper blue space">
                  <p className="content">
                    So sieht dein
                    <br />
                    <strong>Engagement</strong> aus!
                  </p>
                  {data?.activity?.solutions === 0 ? (
                    <p className="content">
                      Hier ist’s ganz <br />
                      schön ruhig…{" "}
                      <strong>
                        Zeit,
                        <br /> in Schwung zu kommen!
                      </strong>
                    </p>
                  ) : (
                    <img alt="bublesPoints" className="points" src={points} />
                  )}
                  <p className="des center">
                    <strong>Du hast </strong>
                    <span>
                      {" "}
                      {data?.activity === null ? 0 : data?.activity?.solutions}
                    </span>
                    <strong>
                      {" "}
                      Aktivitäten <br />
                      abgeschlossen
                    </strong>
                    <br />
                    <br />
                    <strong>Du hast </strong>
                    <span>
                      {" "}
                      {data?.activity === null ? 0 : data?.activity?.stories}
                    </span>
                    <strong>
                      {" "}
                      Inspiration <br /> Stories angeschaut
                    </strong>
                  </p>
                </div>
              );
            case "blue-3":
              const ratio = data?.login === null ? 0 : data?.login?.ratio;
              const dataValues = Object.values(ratio);
              const maxValue = Math.max(...dataValues);
              const maxDays = Object.keys(ratio).filter(
                (day) => ratio[day] === maxValue
              );
              const maxDay = maxDays[0];
              const highlightIndex = Object.keys(ratio).indexOf(maxDay);
              const dayTranslations = {
                monday: "Montag ",
                tuesday: "Dienstag ",
                wednesday: "Mittwoch ",
                thursday: "Donnerstag ",
                friday: "Freitag ",
                saturday: "Samstag ",
                sunday: "Sonntag ",
              };

              return (
                <div className="content-wrapper blue">
                  <p className="content">
                    <strong> Du hast dich </strong>
                    <span>
                      {data?.login === null ? 0 : data?.login?.count}
                    </span>{" "}
                    <strong>
                      {" "}
                      -mal <br /> eingeloggt – und <br />
                      damit mehr als{" "}
                    </strong>
                    <span>
                      {data?.login === null ? 0 : data?.login?.percentile}%
                    </span>{" "}
                    <strong>der anderen!</strong> 🔥
                  </p>
                  {(data.login === null || data?.login?.percentile <= 5) && (
                    <p className="des">Klingt nach ’nem richtig guten Start!</p>
                  )}
                  {data.login !== null && (
                    <>
                      <p className="des">Am aktivsten warst du am:</p>
                      <p className="title">
                        <span>{dayTranslations[maxDay]}</span>
                      </p>
                      <PilarDiagram
                        dataValues={dataValues}
                        highlightIndex={highlightIndex}
                      />
                    </>
                  )}
                </div>
              );
            case "blue-4":
              return (
                <div className="content-wrapper blue">
                  <img
                    alt="collection"
                    src={collection}
                    className="collection"
                  />
                  <p className="content">
                    Deine Sammlung
                    <br /> enthält
                    <span> {data?.coupon ? data?.coupon.count : 0}</span> <br />
                    eingelöste Gutscheine
                  </p>
                  <p className="des">
                    Du hast damit mehr erreicht als{" "}
                    <span>
                      {data?.coupon === null ? 0 : data?.coupon?.percentile}%{" "}
                    </span>
                    aller Nutzer!
                  </p>
                  {data?.coupon?.count <= 5 && (
                    <p className="des">
                      Na, schaffst du nächstes Jahr ’ne
                      <br /> <strong>neue Bestmarke?</strong>
                    </p>
                  )}
                </div>
              );
            case "red-1":
              return (
                <div className="content-wrapper red top">
                  {data?.coupon?.favourite?.catalogue ? (
                    <p className="content">
                      Liebe auf den{" "}
                      <strong>
                        {" "}
                        ersten <br /> Klick?
                      </strong>{" "}
                      💘
                    </p>
                  ) : (
                    <p className="content">
                      Wartest du noch auf <br />
                      deinen{" "}
                      <strong>
                        {" "}
                        ersten
                        <br /> Funken? ✨
                      </strong>
                    </p>
                  )}
                  <div className="award-card-wrapper">
                    {data?.coupon?.favourite?.catalogue ? (
                      <AwardCard
                        mobileImg={
                          data?.coupon?.favourite?.catalogue?.thumbnail?.file
                            ?.url
                        }
                        desktopImg={
                          data?.coupon?.favourite?.catalogue?.thumbnail?.file
                            ?.url
                        }
                        imgDesc={
                          data?.coupon?.favourite?.catalogue?.thumbnail?.file
                            ?.url
                        }
                        copy={parseCMSBold(
                          data?.coupon?.favourite?.catalogue?.content
                            ?.description
                        )}
                        points={data?.coupon?.favourite?.catalogue?.price}
                        brands={data?.coupon?.favourite?.catalogue?.brands}
                        disabled={false}
                        ident={data?.coupon?.favourite?.catalogue?.ident}
                        availabilityLevel={
                          data?.coupon?.favourite?.catalogue?.availabilityLevel
                        }
                        level1={true}
                        level2={true}
                        level3={true}
                        hasLevel={true}
                        stores={data?.coupon?.favourite?.catalogue?.stores}
                        inStock={true}
                        hasPoints={true}
                      />
                    ) : (
                      <img src={noneCoupe} alt="noneCoupe" />
                    )}
                  </div>
                  {data?.coupon?.favourite?.catalogue ? (
                    <>
                      <p className="des">
                        <strong>Du hast es dir schon</strong>
                      </p>
                      <p className="content">
                        {" "}
                        <strong>
                          <span>{data?.coupon?.favourite?.count} </span>
                          Mal geschnappt!
                        </strong>
                      </p>
                    </>
                  ) : (
                    <p className="des">
                      <strong>
                        Du hast noch keinen Coupon eingelöst! Schau dir den
                        Katalog an und schnapp dir heute deinen ersten.
                      </strong>
                    </p>
                  )}
                </div>
              );
            case "red-2":
              return (
                <div className="content-wrapper red space">
                  <p className="content">
                    Deine
                    <strong>
                      {" "}
                      Checkout
                      <br />
                      -Story
                    </strong>{" "}
                    bis jetzt.
                  </p>

                  <div className="content space">
                    <p className="des">
                      <strong>Du hast:</strong>
                    </p>
                    <p className="des">
                      <span>
                        {data?.order ? data?.order?.glo : 0} Bestellungen
                      </span>
                      <br />
                      <strong> bei myglo.com/de aufgegeben!</strong>
                    </p>
                    <p className="des">
                      <span>
                        {data?.order ? data?.order?.vuse : 0} Bestellungen
                      </span>
                      <br />
                      <strong>bei vuse.com/de aufgegeben!</strong>
                    </p>
                    {!data?.order && (
                      <p className="des">
                        <br />
                        <br />
                        <strong>Dein Warenkorb vermisst dich! </strong>
                      </p>
                    )}
                  </div>
                  <div className="content"></div>
                </div>
              );
            case "red-3":
              return (
                <div className="content-wrapper red brands">
                  {data?.brand.glo && !data?.brand.vuse && (
                    <img className="brand" src={glo} alt="glo™" />
                  )}
                  {data?.brand.vuse && !data?.brand.glo && (
                    <img className="brand" src={vuse} alt="Vuse" />
                  )}
                  {data?.brand.glo && data?.brand.vuse && (
                    <img className="brand both" src={both} alt="glo™" />
                  )}
                  <p className="title">
                    Deine <br /> <strong>Lieblingsmarke</strong> ist:
                    <br />
                    <span>
                      {data?.brand.glo && !data?.brand.vuse && "glo™"}
                      {data?.brand.vuse && !data?.brand.glo && "Vuse"}
                      {data?.brand.glo && data?.brand.vuse && "glo™ & Vuse"}
                    </span>
                  </p>
                </div>
              );
            case "gold-1":
              return (
                <div className="content-wrapper gold">
                  <img alt="icLogo" className="icLogo" src={icLogo} />
                  <p className="content">
                    Danke,{" "}
                    <strong>
                      dass du Teil
                      <br />
                      des Inspiration <br />
                      Clubs bist! 💖
                    </strong>
                  </p>
                  <p className="des">
                    <strong>Gleiche Zeit,</strong> nächstes Jahr wieder? 💫
                  </p>
                </div>
              );
            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
}
